<section id="case-study" class="bg-slate-50 py-24 sm:py-28">
  <div class="mx-auto max-w-page px-4 sm:px-6 lg:px-8">
    <div class="grid gap-12 lg:grid-cols-2 lg:items-stretch lg:gap-16">

      <div class="relative h-full min-h-[18rem] overflow-hidden rounded-[2rem]">
        <img
          src="assets/images/landing/forms.webp"
          alt="Event review sentiment insights dashboard"
          width="1600"
          height="1066"
          loading="lazy"
          decoding="async"
          class="h-full w-full object-cover" />

        <div class="absolute bottom-4 left-4 rounded-full bg-white/90 px-4 py-2 text-caption font-medium text-slate-700 backdrop-blur">
          Sentiment insights
        </div>
      </div>

      <div class="flex flex-col gap-8">
        <div class="flex flex-col gap-4">
          <p class="text-caption font-semibold uppercase tracking-[0.2em] text-slate-500">
            Customer story
          </p>

          <h2 class="text-h2 font-medium text-slate-950">
            Event review sentiments, made easy to understand
          </h2>
        </div>

        <p class="text-body1 leading-8 text-slate-600">
          After each event, feedback forms pile up — FormOps turns open-ended responses
          into clear sentiment trends and themes teams can act on quickly.
        </p>

        <div class="flex flex-col gap-4">
          <blockquote class="border-l-4 border-primary-500 pl-5 text-body1 italic leading-8 text-slate-700">
            "We used to spend hours reading event reviews. Now the insights surface
            automatically — positive, neutral, and negative signals are obvious at a glance."
          </blockquote>

          <p class="text-body3 font-medium text-slate-500">
            — Jordan M., Events Program Lead
          </p>
        </div>

        <div class="flex flex-wrap gap-8">
          <div class="flex flex-col gap-1">
            <p class="text-h4 text-slate-950">72%</p>
            <p class="text-body3 text-slate-500">Positive sentiment</p>
          </div>

          <div class="flex flex-col gap-1">
            <p class="text-h4 text-slate-950">34%</p>
            <p class="text-body3 text-slate-500">Faster review turnaround</p>
          </div>

          <div class="flex flex-col gap-1">
            <p class="text-h4 text-slate-950">AI</p>
            <p class="text-body3 text-slate-500">Auto-generated summaries</p>
          </div>
        </div>
      </div>

    </div>
  </div>
</section>
